import { Icon } from "@chakra-ui/icons"
import React from "react"

const FaxBoldIcon = props => {
  return (
    <Icon viewBox="0 0 15.73 15.73" {...props}>
      <g>
        <path
          d="M9.17 7.74H8.09v3.9h-.92v-3.9h-.93V7h.93V6a3.13 3.13 0 01.09-.77 1.54 1.54 0 01.3-.6 1.62 1.62 0 01.55-.41 2.08 2.08 0 01.8-.14 2 2 0 01.58.07L9.38 5H8.92a.88.88 0 00-.43.1.6.6 0 00-.25.25 1 1 0 00-.12.36 2.77 2.77 0 000 .42V7h1.05z"
          fill="currentColor"
        />
        <path
          d="M15.23 15.23H.5V.5h14.73z"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
      </g>
    </Icon>
  )
}

export default FaxBoldIcon
